import gql from 'graphql-tag';

export default fields => gql`
query {
  listChannels {
    items {
      __typename
      ${[...['id', 'name'].concat(fields)]}     
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Channels/AllQuery.js